export const CHESTS = {
  // match reward chests
  WOODEN: 'chest_wooden',
  BRONZE: 'chest_bronze',
  SILVER: 'chest_silver',
  GOLD: 'chest_gold',
  DIAMOND: 'chest_diamond',
  RUBY: 'chest_ruby',
  GOD: 'chest_god',

  // shop chests
  SKINS_IRON: 'chest_skins_iron',
  SKINS_SILVER: 'chest_skins_silver',
  SKINS_GOLD: 'chest_skins_gold',
  UNIT_SKINS_IRON: 'chest_unit_skins_iron',
  UNIT_SKINS_SILVER: 'chest_unit_skins_silver',
  UNIT_SKINS_GOLD: 'chest_unit_skins_gold',
  RANDOM_DEFAULT: 'chest_random_default',
  RANDOM_EPIC: 'chest_random_epic',
  RANDOM_LEGENDARY: 'chest_random_legendary',
  ETERNAL: 'chest_eternal',

  TUTORIAL_SKINS_GOLD: 'chest_tutorial_skins_gold',
}